<template>
  <div class="warehouse" v-if="activePlanModel === 'c'">
    <v-container>
      <v-row>
        <v-col cols="12" class="md-pl-0 pb-0 mb-0 ">
          <h1 class="primary--text mb-0">
            Hauptlager
          </h1>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="px-0 px-sm-3">
      <div class="sl-expansion-panel-header sticky-row section-switch main-header">
        <div class="panel-title">
          <template v-if="isMobile">
            <v-select
                v-model="currentSection"
                :items="config.sections"
                color="primary"
                outlined
            >
              <template v-slot:item="{ item, index }">
                {{ $t('sl.sections.' + item) }}
              </template>

              <template v-slot:selection="{ item, index }">
                {{ $t('sl.sections.' + item) }}
              </template>
            </v-select>
          </template>
          <template v-else>
            <div class="tab-panel">
              <button
                  v-for="(section, index) in config.sections"
                  :key="index"
                  class="tab-button mr-3 mb-3"
                  :class="{ 'active': currentSection === section }"
                  @click="currentSection = section"
              >
                <div
                    v-if="section === 'basket'"
                    class="icon-warenkrob mt-1"
                ></div>
                {{ $t('sl.sections.' + section) }}
              </button>
            </div>
          </template>
        </div>
        <div class="panel-info" v-if="isCommissioningSection">
          <HistoryDatePicker
              v-model="selectedDates"
              :max-date="maxDate"
              style="width: 250px"
          />

          <CheckboxSelect
              v-model="selectedStatus"
              label="Status:"
              button-text="Aufträge anzeigen"
              :items="config.statusOrderTypes"
          />

          <v-select
              v-model="selectedFilter"
              :items="config.sortingTypes"
              outlined
              dense
              color="seondary"
              style="max-width: 200px;"
              prefix="Sortierung: "
          />
        </div>
      </div>
    </v-container>

    <v-container class="px-0 px-md-3">
      <component :is="sectionComponent"/>
    </v-container>
  </div>
</template>

<script>
import OrderExpansionPanel from "@/components/SmartLogistics/Warehouse/Order/OrderExpansionPanel.vue";
import {mapGetters} from "vuex";
import Commissioning from "@/components/SmartLogistics/Warehouse/Views/Commissioning.vue"
import Order from "@/components/SmartLogistics/Warehouse/Views/Order.vue";
import {ModelViewMixin} from "@/mixins/SmartLogistics/ModelView";
import CheckboxSelect from "@/components/form/CheckboxSelect.vue";
import HistoryDatePicker from "@/components/form/HistoryDatePicker.vue";
import History from "@/components/SmartLogistics/Order/History/History.vue";

export default {
  name: 'warehouse',
  components: {HistoryDatePicker, CheckboxSelect, OrderExpansionPanel},
  mixins: [ModelViewMixin],

  data() {
    return {}
  },

  computed: {
    ...mapGetters({
      config: 'smartLogisticWarehouse/config',
      isMobile: 'system/isMobile',
      searchIsActive: 'smartLogisticSettings/searchIsActive',
      activePlanModel: 'smartLogisticSettings/planModel'
    }),

    maxDate() {
      return this.$moment().format('YYYY-MM-DD')
    },

    selectedDates: {
      get() {
        return this.$store.getters['smartLogisticWarehouse/selectedDates']
      },
      set(value) {
        this.$store.commit('smartLogisticWarehouse/setSelectedDates', value)
      }
    },

    selectedStatus: {
      get() {
        return this.$store.getters['smartLogisticWarehouse/selectedStatus']
      },
      set(value) {
        this.$store.commit('smartLogisticWarehouse/setSelectedStatus', value)
      }
    },

    selectedFilter: {
      get() {
        return this.$store.getters['smartLogisticWarehouse/selectedSortingType']
      },
      set(value) {
        this.$store.commit('smartLogisticWarehouse/setSelectedSortingType', value)
      }
    },

    isCommissioningSection() {
      return this.currentSection === 'commissioning'
    },

    sectionComponent() {
      if (this.currentSection === 'basket') return Order
      if (this.currentSection === 'order-history') return History

      return Commissioning
    },

    currentSection: {
      get() {
        return this.$store.getters['smartLogisticWarehouse/currentSection']
      },
      set(value) {
        this.$store.commit('smartLogisticWarehouse/setCurrentSection', value)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-panel button {
  display: flex;
  gap: 0.5rem;
}
</style>
